import { styled } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { AiOutlinePlus } from "react-icons/ai";
import { CgExport, CgImport } from "react-icons/cg";
import { HiOutlineMail } from "react-icons/hi";

import { Button } from "../../../../components/Form";

const styles = makeStyles(() => ({
  seaTypeLabel: {
    color: "#308CDB",
    fontWeight: 500,
  },
  airTypeLabel: {
    color: "#38CFC4",
    fontWeight: 500,
  },

  shipmentsGridWrapper: {
    padding: "16px 32px",
  },
  emailSent: {
    color: "#12B76A",
  },
  emailNotSent: {
    color: "#475467",
  },
  menuTitle: {
    margin: 16,
    fontSize: 18,
    fontWeight: 700,
    fontStyle: "bold",
  },
  inputFile: {
    display: "none",
  },
  button: {
    cursor: "pointer",
  },
  badge: {
    minWidth: "9.375rem",
  },
  menu: {
    marginTop: "4px",
  },
}));

export const PlusIcon = styled(AiOutlinePlus)(() => ({
  marginRight: "8px",
}));
export const ExportIcon = styled(CgExport)(() => ({
  marginRight: "8px",
}));
export const MailIcon = styled(HiOutlineMail)(() => ({
  marginRight: "8px",
}));
export const ImportIcon = styled(CgImport)(() => ({
  marginRight: "8px",
}));
export const NoWrapButton = styled(Button)(() => ({
  whiteSpace: "nowrap",
  minWidth: "110px",
}));

export default styles;
